import { HelpfulVideo } from 'app/components/HelpfulVideo'
import { Container } from 'app/containers/Container'
import { Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { getBrandHelpers, getBrandInfo } from 'config'
import { IHelpfulVideo } from 'config/interfaces';
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Alert, Button, ButtonGroup, Col, FormGroup, Modal, ModalBody, Panel, Row } from 'react-bootstrap'
import { default as InfiniteCalendar, ReactInfiniteCalendarProps } from 'react-infinite-calendar'
import { Link } from 'react-router-dom'

interface IIntroductionContainerState {
  showIntroduction: boolean
  profile: Profile
  helpfulVideo: IHelpfulVideo
}

class Introduction extends Container<{}, IIntroductionContainerState> {
  state: IIntroductionContainerState = {
    showIntroduction: true,
    profile: undefined,
    helpfulVideo: undefined
  }

  componentWillMount() {
    this.Actions.Nav.showDefaultNavRoutes()
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.getNative('info')

      if (profile) {
        const showIntroduction = profile.showIntroduction
        this.setState({ profile, showIntroduction })
      }
    })
    // tslint:disable-next-line:no-console
    console.log('introduction.componentWillMount entered')
  }

  onShowIntroChange() {
    const showIntroduction = !this.state.showIntroduction
    this.setState({ showIntroduction })
    // tslint:disable-next-line:no-console
    console.log('showIntroduction is now: ' + showIntroduction)
    this.updateShowIntroduction(this.state.profile, showIntroduction)
  }

  renderHelpfulVideoLinks() {
    if (0 === getBrandInfo().introductionVideos.length) { return null }
    return <article>
      <h4>Helpful Videos</h4>
      <div>
        {_.map(getBrandInfo().introductionVideos, (v, index) => {
          if (v.suppressLine) {
            return (
              <span key={index}>
                &nbsp;<a className="modal-trigger" href="javascript:void(0)"
                  onClick={() => this.setState({ helpfulVideo: v })}>
                  {v.caption}
                </a>
              </span>)
          } else {
            return (
              <span key={index}>
                {(0 !== index) && <br />}
                <a className="modal-trigger" href="javascript:void(0)"
                  onClick={() => this.setState({ helpfulVideo: v })}>
                  <i className="fa fa-fw fa-youtube-play"></i>{v.caption}
                </a>
              </span>)
          }
        })}
      </div>
    </article>
  }

  render() {
    return (

      <section className="container about-container" id="about">
        <Row>
          <Col mdOffset={1} md={10}>
            <h1 className="title">How can this calculator help you?</h1>
            <Row>
              <Col md={8}>
                {getBrandInfo().markup.introduction.intro1}
                {this.renderHelpfulVideoLinks()}
              </Col>
              <Col md={4}>
                <img className="img-responsive" src="/assets/img/monitor-screenshot.png" alt="" />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={7}>
                <img className="img-responsive thinBorder" src="/assets/img/screen-1.2a.png" alt="" />
              </Col>
              <Col md={5}>
                <p className="lead">You can also choose to only enter info for individual sections; it's up to you and what you need to help you plan your financial future. Go at your own pace.</p>
              </Col>
            </Row>
            {getBrandInfo().markup.introduction.intro2}
            <Row>
              <Button bsStyle="primary" href="#/dashboard">
                Get Started
              </Button>
            </Row>
            <Row>
              <br />
              <label>
                <input type="checkbox" onChange={(e) => this.onShowIntroChange()}
                  checked={!this.state.showIntroduction} />
                don't show this introduction again
              </label>
            </Row>
          </Col>
        </Row>

        <HelpfulVideo info={this.state.helpfulVideo} onClose={() => this.setState({ helpfulVideo: undefined })} />
      </section>
    )
  }

}

export {
  Introduction
}



// WEBPACK FOOTER //
// ./src/app/containers/Introduction/index.tsx